
export let PROFILE_DETAILS:any = "Your Details";
export let SALUTATION:any = "Title";
export let FIRSTNAME:any = "First Name";
export let LASTNAME:any = "Last Name";
export let EMAIL:any = "Email";
export let PHONE:any = "Phone";
export let BUSINESS_DETAILS:any = "Business Details";
export let BUSINESS_NAME:any = "Business Name";
export let BUSINESS_EMAIL:any = "Business Email";
export let BUSINESS_PHONE:any = "Business Phone";
export let ADDRESS:any = "Business Address";
export let ADDRESS_1:any = "Address";
export let ZIP_CODE:any = "Zip Code";
export let CITY:any = "City";
export let STATE:any = "State";
export let WEBSITE:any = "Website";
export let SERVICE: any = "Service";
export const MONTH: any ="Month"
export const INDUSTRY: any ="Industry"
export const SUB_INDUSTRY: any ="Sub Industry"
export const DAY: any ="Day"
export const YEAR: any ="Year"
export const MEMBER_SINCE: any ="Member since"
